import { Fragment } from "react";
import { View } from "react-native";

import type { ScenarioImageSource } from "../data/scenarios";
import { ScenarioImage } from "./ScenarioImage";
import { ScenarioMarkdown } from "./ScenarioMarkdown";

export const ScenarioSummary = ({
	paragraphs,
	media,
	fontSize = 14,
	imageMaxWidth,
}: {
	paragraphs: string[];
	media: ScenarioImageSource[];
	fontSize?: number;
	imageMaxWidth?: number;
}) => {
	return (
		<View style={{ gap: 8 }}>
			{paragraphs.map((text, index) => (
				<Fragment key={text}>
					<ScenarioMarkdown
						text={text}
						fontSize={fontSize}
						paragraphSpacing={4}
					/>
					{index === 0
						? media.map((image) => (
								<ScenarioImage
									key={image.url}
									image={image}
									maxWidth={imageMaxWidth}
								/>
							))
						: null}
				</Fragment>
			))}
		</View>
	);
};
